/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/navigation.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Navigation
 */
export interface Navigation {
    /**
     * @generated from protobuf field: optional string app_section = 1;
     */
    app_section?: string;
    /**
     * @generated from protobuf field: optional string page = 2;
     */
    page?: string;
    /**
     * @generated from protobuf field: optional string filter = 3;
     */
    filter?: string;
    /**
     * @generated from protobuf field: optional string url = 4;
     */
    url?: string;
    /**
     * @generated from protobuf field: optional string deeplink_url = 5;
     */
    deeplink_url?: string;
    /**
     * @generated from protobuf field: optional string origin_page = 6;
     */
    origin_page?: string;
    /**
     * @generated from protobuf field: optional string origin_component = 7;
     */
    origin_component?: string;
    /**
     * @generated from protobuf field: optional string origin_element = 8;
     */
    origin_element?: string;
    /**
     * @generated from protobuf field: optional int64 origin_component_index = 9;
     */
    origin_component_index?: string;
    /**
     * @generated from protobuf field: optional string origin_component_type = 10;
     */
    origin_component_type?: string;
    /**
     * @generated from protobuf field: optional int64 origin_element_index = 11;
     */
    origin_element_index?: string;
    /**
     * @generated from protobuf field: optional string origin_dialog_component = 12;
     */
    origin_dialog_component?: string;
    /**
     * @generated from protobuf field: optional string origin_dialog_element = 13;
     */
    origin_dialog_element?: string;
    /**
     * @generated from protobuf field: optional int64 origin_dialog_element_index = 14;
     */
    origin_dialog_element_index?: string;
    /**
     * @generated from protobuf field: optional string origin_app_section = 15;
     */
    origin_app_section?: string;
    /**
     * @generated from protobuf field: optional string origin_filter = 16;
     */
    origin_filter?: string;
    /**
     * @generated from protobuf field: optional string page_variant = 17;
     */
    page_variant?: string;
    /**
     * @generated from protobuf field: optional string origin_page_variant = 18;
     */
    origin_page_variant?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Navigation$Type extends MessageType<Navigation> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Navigation", [
            { no: 1, name: "app_section", kind: "scalar", localName: "app_section", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "home", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "First level of Navigation i.e. Home, Movies, etc" } },
            { no: 2, name: "page", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "program_detail", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Second level of Navigation i.e. Soccer, Football, Rugby" } },
            { no: 3, name: "filter", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Used to pass in the analytics key of Stac Pages." } },
            { no: 4, name: "url", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "https://www.fubo.tv/watch", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "URL of the page. Currently this applies to web only and web should track it for all the events whenever they track 'data.event_context.page' property." } },
            { no: 5, name: "deeplink_url", kind: "scalar", localName: "deeplink_url", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "fr_fr/p/1423427-19/uci-world-tour---tour-de-france---13e-etape--le-bourg-doisans---saint-etienne-1926-km-le-bourg-doisans---saint-etienne-1926-km---2022", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Link that comes from outside the app. For example: Google Watch Actions." } },
            { no: 6, name: "origin_page", kind: "scalar", localName: "origin_page", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "home", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Previous page in user navigation." } },
            { no: 7, name: "origin_component", kind: "scalar", localName: "origin_component", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "sport slider", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Component used to navigate to the page (Molotov 'section')." } },
            { no: 8, name: "origin_element", kind: "scalar", localName: "origin_element", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???." } },
            { no: 9, name: "origin_component_index", kind: "scalar", localName: "origin_component_index", opt: true, T: 3 /*ScalarType.INT64*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "A number representing which row amongst similar components the event was sourced from." } },
            { no: 10, name: "origin_component_type", kind: "scalar", localName: "origin_component_type", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "carousel", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Component Type." } },
            { no: 11, name: "origin_element_index", kind: "scalar", localName: "origin_element_index", opt: true, T: 3 /*ScalarType.INT64*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "A number representing which row amongst similar components the event was sourced from." } },
            { no: 12, name: "origin_dialog_component", kind: "scalar", localName: "origin_dialog_component", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "???", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???." } },
            { no: 13, name: "origin_dialog_element", kind: "scalar", localName: "origin_dialog_element", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "???", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???." } },
            { no: 14, name: "origin_dialog_element_index", kind: "scalar", localName: "origin_dialog_element_index", opt: true, T: 3 /*ScalarType.INT64*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???." } },
            { no: 15, name: "origin_app_section", kind: "scalar", localName: "origin_app_section", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "home", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Origin Top level navigation name." } },
            { no: 16, name: "origin_filter", kind: "scalar", localName: "origin_filter", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "???", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???." } },
            { no: 17, name: "page_variant", kind: "scalar", localName: "page_variant", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "free, us-latino", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Page variants info, users belong to different cohorts would see different pages." } },
            { no: 18, name: "origin_page_variant", kind: "scalar", localName: "origin_page_variant", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "free, us-latino", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Origin Page variants info, users belong to different cohorts would see different pages." } }
        ]);
    }
    create(value?: PartialMessage<Navigation>): Navigation {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Navigation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Navigation): Navigation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string app_section */ 1:
                    message.app_section = reader.string();
                    break;
                case /* optional string page */ 2:
                    message.page = reader.string();
                    break;
                case /* optional string filter */ 3:
                    message.filter = reader.string();
                    break;
                case /* optional string url */ 4:
                    message.url = reader.string();
                    break;
                case /* optional string deeplink_url */ 5:
                    message.deeplink_url = reader.string();
                    break;
                case /* optional string origin_page */ 6:
                    message.origin_page = reader.string();
                    break;
                case /* optional string origin_component */ 7:
                    message.origin_component = reader.string();
                    break;
                case /* optional string origin_element */ 8:
                    message.origin_element = reader.string();
                    break;
                case /* optional int64 origin_component_index */ 9:
                    message.origin_component_index = reader.int64().toString();
                    break;
                case /* optional string origin_component_type */ 10:
                    message.origin_component_type = reader.string();
                    break;
                case /* optional int64 origin_element_index */ 11:
                    message.origin_element_index = reader.int64().toString();
                    break;
                case /* optional string origin_dialog_component */ 12:
                    message.origin_dialog_component = reader.string();
                    break;
                case /* optional string origin_dialog_element */ 13:
                    message.origin_dialog_element = reader.string();
                    break;
                case /* optional int64 origin_dialog_element_index */ 14:
                    message.origin_dialog_element_index = reader.int64().toString();
                    break;
                case /* optional string origin_app_section */ 15:
                    message.origin_app_section = reader.string();
                    break;
                case /* optional string origin_filter */ 16:
                    message.origin_filter = reader.string();
                    break;
                case /* optional string page_variant */ 17:
                    message.page_variant = reader.string();
                    break;
                case /* optional string origin_page_variant */ 18:
                    message.origin_page_variant = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Navigation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string app_section = 1; */
        if (message.app_section !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.app_section);
        /* optional string page = 2; */
        if (message.page !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.page);
        /* optional string filter = 3; */
        if (message.filter !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.filter);
        /* optional string url = 4; */
        if (message.url !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.url);
        /* optional string deeplink_url = 5; */
        if (message.deeplink_url !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.deeplink_url);
        /* optional string origin_page = 6; */
        if (message.origin_page !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.origin_page);
        /* optional string origin_component = 7; */
        if (message.origin_component !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.origin_component);
        /* optional string origin_element = 8; */
        if (message.origin_element !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.origin_element);
        /* optional int64 origin_component_index = 9; */
        if (message.origin_component_index !== undefined)
            writer.tag(9, WireType.Varint).int64(message.origin_component_index);
        /* optional string origin_component_type = 10; */
        if (message.origin_component_type !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.origin_component_type);
        /* optional int64 origin_element_index = 11; */
        if (message.origin_element_index !== undefined)
            writer.tag(11, WireType.Varint).int64(message.origin_element_index);
        /* optional string origin_dialog_component = 12; */
        if (message.origin_dialog_component !== undefined)
            writer.tag(12, WireType.LengthDelimited).string(message.origin_dialog_component);
        /* optional string origin_dialog_element = 13; */
        if (message.origin_dialog_element !== undefined)
            writer.tag(13, WireType.LengthDelimited).string(message.origin_dialog_element);
        /* optional int64 origin_dialog_element_index = 14; */
        if (message.origin_dialog_element_index !== undefined)
            writer.tag(14, WireType.Varint).int64(message.origin_dialog_element_index);
        /* optional string origin_app_section = 15; */
        if (message.origin_app_section !== undefined)
            writer.tag(15, WireType.LengthDelimited).string(message.origin_app_section);
        /* optional string origin_filter = 16; */
        if (message.origin_filter !== undefined)
            writer.tag(16, WireType.LengthDelimited).string(message.origin_filter);
        /* optional string page_variant = 17; */
        if (message.page_variant !== undefined)
            writer.tag(17, WireType.LengthDelimited).string(message.page_variant);
        /* optional string origin_page_variant = 18; */
        if (message.origin_page_variant !== undefined)
            writer.tag(18, WireType.LengthDelimited).string(message.origin_page_variant);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Navigation
 */
export const Navigation = new Navigation$Type();
